<script setup lang="ts">
import BaseContainer from "@/core/components/base/BaseContainer.vue";
import {Info, Store} from "@lucide/vue";
import {useExtensionStore} from "@/stores/extension.store";
import {storeToRefs} from "pinia";
import {computed} from "vue";
import {ExtensionGrid} from "@/extension/components/extension-grid";
import ExtensionNavigationService from "@/extension/services/ExtensionNavigationService";
import {useRoute, useRouter} from "vue-router";
import {ProgramType} from "@/program/interfaces/Program";
import BaseCard from "@/core/components/base/BaseCard.vue";
import BaseCardBody from "@/core/components/base/BaseCardBody.vue";
import Icon from "@/core/components/icon/Icon.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";


const store = useExtensionStore();
const {programExtensions} = storeToRefs(store);

const route = useRoute();
const router = useRouter();

const order = {
    [ProgramType.SUPPORT]: 0,
    [ProgramType.FEATURE]: 1,
    [ProgramType.DISCOUNT]: 2,
    [ProgramType.LOYALTY_CARD]: 3,
};

const enabled = computed(() => {
    return (programExtensions.value ?? [])?.filter((extension) => extension.enabled)
        .sort((a, b) => {
            return (order[a.sub_type] ?? 4) - (order[b.sub_type] ?? 4);
        });
});
</script>

<template>
  <BaseContainer class="p-4 flex flex-col gap-4">
    <h1>Communiquez auprès de vos patients</h1>
    <BaseCard v-if="!enabled?.length">
      <BaseCardBody class="flex flex-col items-center text-center gap-4">
        <div class="p-6 bg-lightPurple-lightest rounded-xl">
          <Icon name="mdi-view-grid-plus" :size="40" color="primary" />
        </div>
        <h1>Aucun programme actif</h1>
        <p class="text-muted-foreground">
          Vous ne participez à aucun programme pour le moment.<br>
          Rejoignez des programmes proposés par vos partenaires
          depuis<br>le store pour communiquer avec leurs patientèles.
        </p>
        <router-link :to="{name: 'extension-store'}">
          <BaseButton primary class="!font-semibold">
            <Store class="mr-2 size-6" />
            Découvrir le store
          </BaseButton>
        </router-link>
      </BaseCardBody>
    </BaseCard>
    <template v-else>
      <div class="bg-white border rounded-lg px-3 py-2 flex items-center gap-3">
        <Info class="size-5 inline-flex text-primary shrink-0" />
        <span
          class="leading-none text-sm text-muted-foreground"
        >
          Sélectionnez un programme pour accéder à sa patientèle et lui envoyer un message.
        </span>
      </div>
      <ExtensionGrid
        title=""
        :extensions="programExtensions"
        @extension-click="extension => ExtensionNavigationService.navigate(extension, router, route)"
      />
    </template>
  </BaseContainer>
</template>

<style scoped>

</style>
